<style scoped>
    .invoice-box {
        margin: auto;
        padding: 30px;
        box-shadow: 2px 2px 5px #b2b2b2;
        border-radius: 5px;
        font-size: 14px;
        line-height: 24px;
       
       background-color:white;
    }

        .invoice-box table {
            width: 100%;
            line-height: inherit;
            text-align: left;
            border-bottom: 1px solid #b2b2b2
        }

.invoice-box table td {
  vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  /*     padding-bottom:10px;*/
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

table.payment {
  border: 1px solid;
  width: auto;
  margin-top: 20px;
  background-color: rgb(248, 248, 248);
  border-width: 1px;
  border-style: solid;
  border-color: rgb(166, 166, 166);
}

table.payment td {
  padding-bottom: 0 !important;
  text-align: left !important;
  border: 1px rgb(166, 166, 166) solid !important;
}
table.payment td.min-width {
  min-width: 40px !important;
}

table.balance td.min-width {
  min-width: 80px !important;
}

table.balance {
  width: auto;
  margin-top: 20px;
  border: 1px #4586c6 solid !important;
  background-color: rgb(248, 248, 248);
  border-width: 1px;
  border-style: solid;
  border-color: rgb(166, 166, 166);
}

table.balance td {
  padding-bottom: 0 !important;
  text-align: left !important;
  border: 1px rgb(166, 166, 166) solid !important;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}
</style>
<template>
   
    <div class="col-md-12">
        <div class="row">
            <div class="col-6">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / {{ propertyName }}</span>
                        </template>
                        Receipt
                    </span>
                    <p style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;

            text-transform: uppercase;
          ">
                        Receipt
                    </p>
                </div>
            </div>
            <div class="col-6 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                        <router-link class="btn btn-table" :to="{
                  name: 'property',
                  params: { buildingId: buildingId, buildingName: buildingName },
                }"><i class="fas fa-plus"></i></router-link>-->


                    <userMenu />
                </div>
            </div>
        </div>
        <div class="col-md-6 offset-md-3" style="margin-top: -10px;">
            


            <div class="">
                <div class="invoice-box" id="element-to-convert" style="background-color:#fff;">
                    <table cellpadding="0" cellspacing="0" style="background-color:#fff;">
                        <tr class="top" style="background-color:#fff;">

                            <td colspan="2" style="background-color:#fff;">
                                <table style="background-color:#fff;">
                                    <tr style="background-color:#fff;">
                                        <td style="width:85%;line-height: 0.8;background-color:#fff;position:relative">
                                            <span style="top:50%;position:absolute;font-size: 14px; font-weight: bold; background-color: #fff;">Receipt Number: {{ payment.id}}</span>
                                           

                                        </td>
                                        <td>
                                            <img :src="imageUrl" alt="avatar" style="float:right;max-width:200px;max-height:120px">
                                       </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr style="height:100px;background-color:#fff;">
                            <td width="50%" style="text-align:left;background-color:#fff;">
                                <span style="color:#b2b2b2">From:</span>
                                <template v-if="settings.invoiceName && settings.invoiceName.length > 0">
                                    <br />
                                    <span style="font-weight: bold"><strong>{{ settings.invoiceName }}</strong></span>

                                </template>
                                <br />
                                <span style="font-weight:bold">{{ building.name }}</span>
                                <br />
                                <span style="color:#b2b2b2">{{ building.address }}</span>
                                
                            </td>
                            <td width="50%" style="text-align:left;background-color:#fff;">
                                <span style="color:#b2b2b2">To:</span>
                                <br />
                                <span style="font-weight:bold">{{ contact.name }}</span>
                                <br />
                                <span style="color:#b2b2b2">{{ property.propertyName }}</span>
                            </td>
                        </tr>
                        <tr style="background-color:#fff;">
                            <td colspan="2" style="background-color:#fff;">
                                <div class="table-responsive" style="background-color:#fff;">
                                    <table class="table table-condensed" style="background-color:#fff;">
                                        <thead>
                                            <tr>
                                                <th>DESCRIPTION</th>
                                                <th style="text-align:right">TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="background-color:rgba(0,125,252,0.3)">{{expenseName}}</td>
                                                <td style="text-align: right; background-color: rgba(0,125,252,0.3)">Payment Amount {{ $filters.currency(payment.amount, "€") }}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td style="text-align: right;"><span style="font-weight:bold">Balance Due </span> {{ $filters.currency(balanceDue, "€") }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <!--<tr class="information">
            <td colspan="2">
              <table style="margin-top: 10px;">
                <tr
                  style="
                    background-color: rgb(248, 248, 248);
                    border-width: 1px;
                    border-style: solid;
                    border-color: rgb(166, 166, 166);
                  "
                >
                  <td>
                    <span
                      style="
                        background-color: #015a6c;
                        color: #fff;
                        text-align: right;
                        display: inline-block;
                        width: 200px;
                      "
                      ><strong style="margin-right: 5px;"
                        >Received From:</strong
                      ></span
                    ><span style="margin-left: 5px;">
                      {{ contact.name }}
                    </span>
                  </td>

                  <td>
                    <span
                      style="
                        background-color: #015a6c;
                        color: #fff;
                        text-align: right;
                        display: inline-block;
                        width: 200px;
                      "
                      ><strong style="margin-right: 5px;"
                        >the amount of €
                      </strong></span
                    >
                    {{ $filters.currency(payment.amount, "€") }}-->
                        <!--Acme Corp.<br>-->
                        <!--</td>
                  </tr>
                  <table>
                    <tr
                      style="
                        background-color: rgb(248, 248, 248);
                        border-width: 1px;
                        border-style: solid;
                        border-color: rgb(166, 166, 166);
                      "
                    >
                      <td>
                        <span
                          style="
                            background-color: #015a6c;
                            color: #fff;
                            text-align: right;
                            display: inline-block;
                            width: 200px;
                          "
                          ><strong style="margin-right: 5px;"
                            >For:</strong
                          ></span
                        ><span style="margin-left: 5px;">
                          {{ expenseName }}
                        </span>
                      </td>
                    </tr>
                  </table>
                  <tr>
                    <td>
                      <table class="balance">
                        <tr>
                          <td
                            colspan="2"
                            style="
                              width: 200px;
                              background-color: #015a6c;
                              color: #fff;
                              padding: 5px;
                              text-align: right;
                            "
                          >
                            <strong>Current Balance: </strong>
                          </td>
                          <td style="padding: 5px;" class="min-width">
                            {{ $filters.currency(currentBalance, "€") }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            colspan="2"
                            style="
                              background-color: #015a6c;
                              color: #fff;
                              padding: 5px;
                              text-align: right;
                            "
                          >
                            <strong> Payment Amount: </strong>
                          </td>
                          <td style="padding: 5px;" class="min-width">
                            {{ $filters.currency(payment.amount, "€") }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            colspan="2"
                            style="
                              background-color: #015a6c;
                              color: #fff;
                              padding: 5px;
                              text-align: right;
                            "
                          >
                            <strong> Balance Due: </strong>
                          </td>
                          <td style="padding: 5px;" class="min-width">
                            {{ $filters.currency(balanceDue, "€") }}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td style="float: right;">
                      <table class="payment">
                        <tr>
                          <td
                            v-if="payment.paymentType == 1"
                            style="background-color: #015a6c; padding: 5px;"
                            class="min-width"
                          ></td>
                          <td
                            v-else
                            style="padding: 5px;"
                            class="min-width"
                          ></td>

                          <td
                            v-if="payment.paymentType == 1"
                            style="
                              padding: 5px;
                              background-color: #38b2ac;
                              color: #fff !important;
                            "
                          >
                            <strong> Cash </strong>
                          </td>
                          <td v-else style="padding: 5px;">
                            <strong> Cash </strong>
                          </td>
                          <td style="padding: 5px;">
                            <div v-if="payment.paymentType == 1">
                              {{ payment.reference }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            v-if="payment.paymentType == 2"
                            style="background-color: #015a6c; padding: 5px;"
                            class="min-width"
                          ></td>
                          <td
                            v-else
                            style="padding: 5px;"
                            class="min-width"
                          ></td>
                          <td
                            v-if="payment.paymentType == 2"
                            style="
                              padding: 5px;
                              background-color: #38b2ac;
                              color: #fff !important;
                            "
                          >
                            <strong> Cheque </strong>
                          </td>
                          <td v-else style="padding: 5px;">
                            <strong> Cheque </strong>
                          </td>
                          <td style="padding: 5px;">
                            <div v-if="payment.paymentType == 2">
                              {{ payment.reference }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            v-if="payment.paymentType == 3"
                            style="background-color: #015a6c; padding: 5px;"
                            class="min-width"
                          ></td>
                          <td
                            v-else
                            style="padding: 5px;"
                            class="min-width"
                          ></td>
                          <td
                            v-if="payment.paymentType == 3"
                            style="
                              padding: 5px;
                              background-color: #38b2ac;
                              color: #fff !important;
                            "
                          >
                            <strong> Money Order </strong>
                          </td>
                          <td v-else style="padding: 5px;">
                            <strong> Money Order </strong>
                          </td>
                          <td style="padding: 5px;">
                            <div v-if="payment.paymentType == 3">
                              {{ payment.reference }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>-->
                    </table>
                    <div style="height:30px;">
                        <p style="float: left;
              margin-right: 150px;margin-top:15px /* padding-top: 5px; */ /* margin-bottom: 5px; */
            ">
                            Online Payment // No.   {{ payment.reference }}
                        </p>
                    </div>
                </div>
                <div class="text-right">
                    <send-receipt :receipt-id="id" :expense-id="expenseId"/>
                    <button type="submit" v-if="false" @click="print()" class="btn btn-cancel" style="margin: 15px; margin-top: 15px; margin-bottom: 0px;">
                        Print
                    </button>
                    <button @click="cancel()" style="margin-top: 15px;" class="btn btn-submit">Cancel</button>
                </div>
            </div>
        </div>
        <div class="row">
      <div class="col-12">
        <a
          @click="$router.go(-1)"
          class="btn btn-cancel"
          style="
            width: 60px;
            display: block;
            margin-left: auto;
            margin-right: 0;
            margin-bottom: 15px;
            margin-top: -5px;

          "
          >Back</a
        >
      </div>
      
    </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
    import { format, parseISO } from "date-fns";
    import html2pdf from "html2pdf.js";
export default {
  data: function () {
    return {
      name: "",
      surname: "",
      phoneNumber: "",
      email: "",
      position: 1,
      id: 0,
      submitted: false,
      formTitle: "Receipt of property",
    //  buildingId: 0,
    //  buildingName: "",
     // propertyId: 0,
     // propertyName: "",
      expenseId: 0,
      property: {},
      building: {},
      payment: {},
      expenseName: "",
      currentBalance: 0,
      balanceDue: 0,
        contact: {},
        imageUrl: "",
        settings: {}
    };
  },
  deactivated(){
    this.$store.commit('property/CLEAR_CURRENT_RECEIPT_ID')
  },
  mounted() {
    this.ensureBuilding();
   // this.buildingName = this.$route.params.buildingName;
    if(this.$route.params.propertyName != null && this.$route.params.propertyName.length > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_NAME', this.$route.params.propertyName)
    if(this.$route.params.propertyId != null && this.$route.params.propertyId > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_ID', this.$route.params.propertyId)
    //this.buildingId = this.$route.params.buildingId;
    if(this.$route.params.id != null && this.$route.params.id > 0)
      this.$store.commit('property/SET_CURRENT_RECEIPT_ID', this.$route.params.id)
    this.id = this.$route.params.id;
    if (this.$route.params.expenseId)
      this.expenseId = this.$route.params.expenseId;

    console.log(this.expenseId);
    this.getCommittee();
  },
        methods: {
            ensureBuilding() {
              const id = Number(this.$route.params.buildingId);
              if (id > 0 && Number(this.building && this.building.id) !== id) {
                this.$store.dispatch("building/fetchBuilding", id);
              }
            },
            print() {
                html2pdf(document.getElementById("element-to-convert"), {
                    margin: 1,
                    filename: "i-was-html.pdf",
                });
            },
    getCommittee: function () {
      if (this.expenseId > 0)
        this.$http
          .get("/payments/expensereceipt?id=" + this.receiptId)
          .then((response) => {
            (this.building = response.data.building),
              // this.buildingName = response.data.building.name,
              (this.payment = response.data.payment);
            this.property = this.payment.property;
            this.expenseName = response.data.expenseName;
            this.currentBalance = response.data.currentBalance;
            this.balanceDue = response.data.balanceDue;
              this.contact = response.data.contact;
              this.settings = response.data.settings
              this.imageUrl = response.data.logo
          });
      else
        this.$http.get("/payments/" + this.receiptId).then((response) => {
          (this.building = response.data.building),
            // this.buildingName = response.data.building.name,
            (this.payment = response.data.payment);
          this.property = this.payment.property;
          this.expenseName = response.data.expenseName;
          this.currentBalance = response.data.currentBalance;
          this.balanceDue = response.data.balanceDue;
            this.contact = response.data.contact;
            this.settings = response.data.settings
            this.imageUrl = response.data.logo
        });
    },
    cancel() {
      this.$router.push({
        name: "payments",
        params: {
          buildingId: this.buildingId,
          buildingName: this.buildingName,
          propertyId: this.propertyId,
          propertyName: this.propertyName,
        },
      });
    },
    customFormatter(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      propertyName:(state) => state.property.currentPropertyName,
      propertyId:(state) => state.property.currentPropertyId,
      receiptId:(state) => state.property.currentReceiptId,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    buildingId(){
      if(this.$route.params.buildingId)
        return this.$route.params.buildingId;
      if(this.building != null)
        return  this.building.id;
      return ""
    },
  },
  // Our Javascript logic
};
</script>
